module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAAAXNSR0IArs4c6QAAANhJREFUGBldj78KwkAMxpOzr+STOOjY1sFFtFXp4uYi2GpPRPyD9g4Hwb6OTyDoI7iJMTmoiDfkSH75ki+QLk1rlpsjESH8PQVvqANRmOV299/gutPcbBl0FOJ6FAfdaoCDophrW7yJfFCQJ1E4kAYlARFpGPltBDzzmjjTZurqEqpXlmXtdn9eCKjBtYlTVlB+9vxyuULvC3mvuj2ehp03Gc6TKBh/DaXaHuQkdrxixz1RO2Wm7UYAIOzZWN+N5YDpolgSQI8VlkEozivoIcKVk5M75QdIwwdSCFu2TPP6qgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/returnLeve.png
// module id = WYmT
// module chunks = 1